import { CHINESE_LANG } from '../constants';
import { LOCALE_MAP } from '../dateConstants';

export const RESTRICTED_LOCALES = [CHINESE_LANG];

export const isAllowedForLocale = (locale: keyof typeof LOCALE_MAP) => !RESTRICTED_LOCALES.includes(locale as string);
